import routerOptions0 from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/Users/abdalrahmansaadulla/Desktop/website/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}